import Vue from "vue";
import { AuthorizationData } from "@/features/Authentication/PlatformUserInfoService";
import SupplierEvent from "@/features/SupplierEvents/SupplierEvent";

export class SupplierEventAuthorizationService {
    private authData: AuthorizationData;

    constructor() {
        this.authData = Vue.prototype.$platformUserInfoService.getUserAuthorizationData();
    }

    public canModifySupplierEvent(supplierEvent: SupplierEvent): boolean {
        return this.authData.supplierIDs.some(id => id == supplierEvent.supplierID) || this.authData.allSuppliersVisible;
    }
}
